// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__pb06W","section_animation-start":"Section_section_animation-start__pTkxY"};